import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

import Typography from "material-ui/Typography";

const styles = () => ({
  root: {
    width: "100%",
  },

  contact: {
    background: "#FFFFFF",
    width: "100%",
    boxSizing: "border-box",
    padding: "20px",
    marginTop: "30px",
  },

  link: {
    color: "#1A65FF",
    textDecoration: "none",
  },
});

class ContactInfoInner extends React.Component {
  render() {
    const { classes, text } = this.props;

    return (
      <div className={classes.root}>
        <Typography variant="body2">{text}</Typography>
        <div className={classes.contact}>
          <Typography variant="body2">
            {"担当者から話を聞きたい: "}
            <a className={classes.link} href={process.env.REACT_APP_SPIR_LINK_SOURCE_OTHER}target="_blank" rel="noopener noreferrer">
              オンラインMTG予約のリンク
            </a>
          </Typography>
          <Typography variant="body2">
            {"メールによるお問い合わせ: "}
            <a className={classes.link} href="mailto:cs@keymanletter.com" target="_blank" rel="noopener noreferrer">
              cs@keymanletter.com
            </a>
          </Typography>
        </div>
      </div>
    );
  }
}

ContactInfoInner.propTypes = {
  classes: PropTypes.object.isRequired,
  text: PropTypes.string,
};

ContactInfoInner.defaultProps = {
  text:
    "プラン変更をご検討いただき誠にありがとうございます。プラン変更をご希望のお客様は、右下のチャットフォームまたは下記いずれかの方法より、ご連絡ください。ご質問のみでもけっこうでございます。ご連絡お待ちしております。",
};

export default withStyles(styles)(ContactInfoInner);



// WEBPACK FOOTER //
// ./src/components/SendLetter/dialogs/ContactInfoInner.jsx